/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.credentials', [])
    .factory('credentialsService', CredentialsService)
    .name;

/*@ngInject*/
function CredentialsService($http, $q) {

    var service = {
        getCredentials: getCredentials,
        saveCredentials: saveCredentials
    }

    return service;

    function getCredentials (entityType, entityId) {
        var deferred = $q.defer();
        $http.get(`/api/credentials/${entityType}/${entityId}`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveCredentials (credentials) {
        var deferred = $q.defer();
        var url = '/api/credentials';
        $http.post(url, credentials).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/credentials.service.js